export default __webpack_public_path__ + "static/media/ic_religious.4814b7f1.svg";